import { formatDkkPrice } from '../lib/format.ts';

/** The header over every ticket price: the listed price already includes United Tickets' ticket fee. */
export const PRICE_HEADER = 'Pris inkl. billetgebyr';

/**
 * The note that goes with the prices. United Tickets adds a flat fee per order — not per ticket —
 * so it can never be part of a unit price. The amount is entered per festival year in the
 * BackOffice; without one the note still says the fee exists.
 */
export function orderFeeNote(orderFee?: number): string {
  const amount = typeof orderFee === 'number' && Number.isFinite(orderFee) && orderFee > 0
    ? ` på ${formatDkkPrice(orderFee)}`
    : '';
  return `Der kommer et ordregebyr${amount} fra United Tickets oveni, fast pr. ordre.`;
}
